import DevicesView from '@/Core.Service.Domain/Devices/Devices.Common/Views/DevicesView.vue';
import DeviceProperties from '@/Core.Service.Domain/Devices/Devices.Common/Views/DeviceProperties.vue';

const DevicesRoute = {
  path: '/devices',
  name: 'DevicesIndex',
  children: [
    {
      path: 'site/:siteId/device-properties',
      name: 'DeviceProperties',
      component: DeviceProperties,
    },
  ],
  component: DevicesView,
  meta: { permission: 'meters:read' },
};

export default [DevicesRoute];
